import type { Message } from "../../../types"
import { jidLocalPart, type Jid } from "../../jid"

export const isOwnMessage = (message: Message, selfJid: Jid): boolean =>
  message.author === jidLocalPart(selfJid)

/**
 * Which conversation a message belongs to. For a group delivery `from` is the
 * room, which IS the conversation; for a 1:1 neither side is the peer on its
 * own, since a message you sent from another tab arrives addressed FROM you.
 */
export const conversationPeer = (message: Message, selfJid: Jid): Jid => {
  const { from, to } = message.routing
  return from !== selfJid ? from : to
}

/** Whether `id` names this message, in either dialect (origin-id or room stanza-id). */
export const messageHasId = (
  message: Message,
  id: string | undefined
): boolean =>
  id !== undefined && (message.id === id || message.roomStanzaId === id)

/** Whether two parsed messages are the same message, in either dialect. */
export const sameMessage = (a: Message, b: Message): boolean =>
  messageHasId(a, b.id) || messageHasId(a, b.roomStanzaId)

export { parse } from "./parse"
